import { render, staticRenderFns } from "./CouponLabel.vue?vue&type=template&id=5051cc59&"
import script from "./CouponLabel.vue?vue&type=script&lang=ts&"
export * from "./CouponLabel.vue?vue&type=script&lang=ts&"
import style0 from "./CouponLabel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports